import {
    createContext,
    useContext,
    FunctionComponent,
    ReactNode,
    useState,
} from "react"
import { LabelValueOptionType } from "../../../types/commonTypes"
import { useViewerContext } from "../../../context/ViewerContext"

// Define the context type
interface NotificationsContextType {
    selectedOrganization: LabelValueOptionType
    updateSelectedOrganization: (organization: LabelValueOptionType) => void
}

const NotificationsContext = createContext<
    NotificationsContextType | undefined
>(undefined)

// Create Provider
const NotificationsContextProvider: FunctionComponent<{
    children: ReactNode
}> = ({ children }) => {
    const viewer = useViewerContext().getViewer()

    // state
    const [selectedOrganization, setSelectedOrganization] =
        useState<LabelValueOptionType>(viewer.currentOrganization)

    // functions
    const updateSelectedOrganization = (organization: LabelValueOptionType) => {
        setSelectedOrganization(organization)
    }

    return (
        <NotificationsContext.Provider
            value={{
                selectedOrganization,
                updateSelectedOrganization,
            }}
        >
            {children}
        </NotificationsContext.Provider>
    )
}

// Custom hook to use the NotificationsContext
const useNotificationsContext = () => {
    const context = useContext(NotificationsContext)
    if (!context) {
        throw new Error(
            "useNotificationsContext must be used within a NotificationsContextProvider"
        )
    }
    return context
}

export { NotificationsContextProvider, useNotificationsContext }
